import { Card, Form, Input, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";
import { useLoading } from "../contexts/LoadingContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const onFinish = async ({ username, password }) => {
    setLoading(true);
    const { data, error } = await supabase
      .from("users")
      .select("id, username, role, phone, don_vi, full_name")
      .eq("username", username)
      .eq("password", password) // ⚠ demo
      .single();

    if (error || !data) {
      message.error("Sai tài khoản hoặc mật khẩu");
      return;
    }

    // ✅ LƯU currentUser
    localStorage.setItem("currentUser", JSON.stringify(data));
    localStorage.setItem("role", data.role);
    
    message.success("Đăng nhập thành công");

    
    setTimeout(() => {
      if (data.role === "admin") {
        navigate("/admin", { replace: true });
      } else {
        navigate("/manage", { replace: true });
      }
    }, 300);
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#0b3d2e",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        title="ĐĂNG NHẬP HỆ THỐNG"
        style={{ width: 360 }}
        header={{ textAlign: "center", fontWeight: "bold" }}
      >
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            label="Tài khoản"
            name="username"
            rules={[{ required: true, message: "Nhập tài khoản" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Mật khẩu"
            name="password"
            rules={[{ required: true, message: "Nhập mật khẩu" }]}
          >
            <Input.Password />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Đăng nhập
          </Button>
        </Form>
      </Card>
    </div>
  );
}
